;(function ( intlNumberEditor, undefined ) {
	var phoneInput;
	var delayTimer;
	var saveCallback;
	var cancelCallback;
	var number_input_field;
	var country_input_field;
	var allowed_country_codes = [];
		
	intlNumberEditor.registerEventListeners = function() {
		$('#number-editor .cancel').on('click', function() {
			$('#number-editor .phonenumber').val('');
			$('#number-editor').dialog('close');
			if (cancelCallback) cancelCallback();
			return false;    
		}); 
		
		$('#number-editor .save').on('click', function() {
			if (!validatePhoneNumber()) {
				return;
			}
			let international = phoneInput.getNumber();
			let national = phoneInput.getNumber(window.intlTelInput.utils.numberFormat.NATIONAL);
			if (saveCallback) saveCallback({national: national, international: international});
			$('#number-editor').dialog('close');
		});

		$('#number-editor .phonenumber').on('input', function() {
            validatePhoneNumber();
		});

		$('#number-editor .phonenumber').on('keyup', function() {
			if (delayTimer) clearTimeout(delayTimer);
			delayTimer = setTimeout(function() {
				delayTimer = null;
				if (validatePhoneNumber()) {
					var phonenumber=phoneInput.getNumber();
					phoneInput.setNumber(phonenumber);
				}
			}, 300);
		}) 		
	}
	
	intlNumberEditor.initialize = function (config = { country_codes: ["us", "gb", "ie"] }) {
		const dialogOptions = {
			title: 'Phone Number',
			width: 650,
			height: 250,
			dialogClass: 'no-close',
			autoOpen: false,
			closeOnEscape: false,
			modal: false,
			close: function () {}
		};
		$('#number-editor').dialog(dialogOptions);

		phoneInput = createPhoneInput(config.country_codes, 'us');
		intlNumberEditor.registerEventListeners();
	}

	intlNumberEditor.setAllowedCountries = function (new_country_codes) {
		const currentCountryCode = phoneInput.selectedCountryData.iso2 || 'us';
		phoneInput.destroy(); // Destroy the current instance

		phoneInput = createPhoneInput(new_country_codes, currentCountryCode);
	}

	intlNumberEditor.getAllowedCountries = function () {
		return allowed_country_codes;
	}

	function createPhoneInput( countryCodes, initialCountry) {
		const phoneInputField = document.querySelector("#number-editor .phonenumber");
		allowed_country_codes = countryCodes;
		return window.intlTelInput(phoneInputField, {
			loadUtils: () => import("intl-tel-input/build/js/utils.js"),
			onlyCountries: allowed_country_codes,
			initialCountry: initialCountry,
			validationNumberTypes: ['FIXED_LINE_OR_MOBILE']
		});
	}

	intlNumberEditor.setCountry = function(country_code) {
		phoneInput.setCountry(country_code);
	}	
	
	intlNumberEditor.editNumber = function(number, save_callback, cancel_callback) {
		saveCallback = save_callback;
		cancelCallback = cancel_callback;
		phoneInput.setNumber(number);
		$('#number-editor').dialog('open'); 
		$('#number-editor input[type=text]:visible').focus();

        $('#number-editor').find('.error').remove();
        $('#number-editor .missing').removeClass('missing');
	}

    let validatePhoneNumber = function () {
        $('#number-editor').find('.error').remove();
        $('#number-editor .missing').removeClass('missing');
        if (!phoneInput.isValidNumber()) {
            $('#number-editor .phonenumber').addClass('missing');
            $('#number-editor .phonenumber').parent().after('<div class="error"><br>Please make sure your phone number is correctly formatted for the country selected!</div>');
            return false;
        }
        return true;
    }


}( window.intlNumberEditor = window.intlNumberEditor || {} ));
